import { DigitalSuiteGenericNavBarBody } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarBody";
import { DigitalSuiteGenericBarHeader } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteGenericNavBarHeader";
import { aiResearchNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/gen-ai-intelligence/aiResearchNavObj";
import { industryAnalysisNavObj31 } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/market-research/industryAnalysisNavObj31";
import { industryResearchNavObj31 } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/market-research/industryResearchNavObj31";
import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";
import { hasAnySelectedCategoryWithSegments } from "app/pages/industry-analysis/common/getSelectedCategory";
import { DEMAND_ANALYSIS_HOME_STATE_NAME } from "app/pages/market-research/shared/constants";
import { ROUTES as AIResearchRoutes } from "single-spa/react-app/config/solutions25/genAIIntelligence/AIResearch/AIResearchConstants";

export const aiResearchNavBarContent = (): ISecondaryBarContents => ({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SecondaryBarHeader: (
        <DigitalSuiteGenericBarHeader
            state={AIResearchRoutes.home}
            title="primary.sidebar.ai.research.title"
        />
    ),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    SecondaryBarBody: <DigitalSuiteGenericNavBarBody navObj={aiResearchNavObj().navList} />,
});

export const industryAnalysisNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={"digitalsuite_webmarketanalysis_home"}
                title={"digitalsuite.navbar.webindustryanalysis.group.category"}
            />
        ),
        SecondaryBarBody: <DigitalSuiteGenericNavBarBody navObj={industryAnalysisNavObj31().navList} />,
    };
};

export const industryResearchNavBarContent = (): ISecondaryBarContents => {
    const hasSelectedCategoryWithSegments = hasAnySelectedCategoryWithSegments();
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state="market_research_home"
                title="digitalsuite.navbar.industry.research.group.market"
            />
        ),
        SecondaryBarBody: (
            <DigitalSuiteGenericNavBarBody navObj={industryResearchNavObj31(hasSelectedCategoryWithSegments).navList} />
        ),
    };
};

export const digitalSuiteSearchInterestNavBarContent = (): ISecondaryBarContents => {
    return {
        SecondaryBarHeader: (
            <DigitalSuiteGenericBarHeader
                state={DEMAND_ANALYSIS_HOME_STATE_NAME}
                title={"digitalsuite.navbar.demand.analysis.group"}
            />
        ),
    };
};
